(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./refresh.less", "../inline-loading"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./refresh.less"), require("../inline-loading"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.refresh, global.inlineLoading);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _refresh, _inlineLoading) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _inlineLoading = _interopRequireDefault(_inlineLoading);
  var _default = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('div', {
        staticClass: "nx-scroll-view-refresh"
      }, [this.isRefreshing ? _c('nx-inline-loading', {
        attrs: {
          "type": "roller"
        }
      }) : _vm._e(), _c('p', {
        staticClass: "refresh-tip"
      }, [_vm._v(_vm._s(_vm.refreshTip))])], 1);
    },
    name: 'nx-scroll-view-refresh',
    components: (0, _defineProperty2.default)({}, _inlineLoading.default.name, _inlineLoading.default),
    props: {
      scrollTop: {
        type: Number,
        default: 0
      },
      isRefreshing: {
        type: Boolean,
        default: false
      },
      isRefreshActive: {
        type: Boolean,
        default: false
      },
      refreshText: {
        type: String,
        default: '下拉可以刷新'
      },
      refreshActiveText: {
        type: String,
        default: '松开立即刷新'
      },
      refreshingText: {
        type: String,
        default: '正在刷新...'
      }
    },
    computed: {
      process: function process() {
        /* istanbul ignore if */
        if (!this.$el || !this.scrollTop) {
          return +this.scrollTop;
        }

        var refreshHeight = this.$el.clientHeight;

        if (Math.abs(this.scrollTop) < refreshHeight / 2) {
          return 0;
        } // first 1/3 is not included in progress


        return (Math.abs(this.scrollTop) - refreshHeight / 2) / (refreshHeight / 2);
      },
      refreshTip: function refreshTip() {
        if (this.isRefreshing) {
          return this.refreshingText;
        } else if (this.isRefreshActive) {
          return this.refreshActiveText;
        } else {
          return this.refreshText;
        }
      }
    }
  };
  _exports.default = _default;
});